import * as types from '../ActionTypes';
import { user } from '@/services/indexnew';

const state = {
	isLoading: false,
	imgItems: [],
	userInfo: {},
	userInfoPart: {},
};
const mutations = {
	[types.SET_USERINFO](st, data) {
		st.userInfo = data;
	},
	[types.SET_USERINFOPART](st, data) {
		st.userInfoPart = data;
	},
};
const actions = {
	async getUserInfo({ state, commit }, payload) {
		const { ok, data } = await user.getUserInfo(payload);
		if (ok) {
			commit('SET_USERINFO', data.data);
			commit('SET_USERINFOPART', data.data);
		}
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
};
